import { SVGAttributes } from 'react';

const ShareIcon = (props: SVGAttributes<SVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
        <defs />
        <g fill="none" fillRule="evenodd">
            <circle cx="3.5" cy="9.5" r="3.5" fill="currentColor" />
            <circle cx="16.5" cy="3.5" r="3.5" fill="currentColor" />
            <circle cx="16.5" cy="16.5" r="3.5" fill="currentColor" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M8.845 7.033L16.5 3.5"
            />
            <path stroke="currentColor" strokeWidth="2" d="M16.5 16.5L3 10" />
        </g>
    </svg>
);
export default ShareIcon;
